import React from 'react';
import { Row, Col, Card, Space } from 'antd';

import { AreaChartOutlined } from '@ant-design/icons';
import { PageContentLayout, PageHeaderLayout } from '../../shared/layout';

import { FiltersBar } from './components/OrgSummary';

import OrgSummaryChart from './components/OrgSummary/OrgSummaryChart';
import CampaignOrderTable from './components/OrgSummary/CampaignOrderTable';
import { useHistory } from 'react-router-dom';

const DisplayPerformanceView = ({
  orgs,
  tableData,
  userPermission,
  byDate,
  byDay,
  campaignOrders,
  selectedCOIds,
  setSelectedCOIds,
  prepareExport,
  onExportWeeklyReport,
}) => {
  // Set Document Title
  document.title = 'Display Analytics';

  // user permission
  const history = useHistory();

  return (
    <React.Fragment>
      <PageHeaderLayout
        title={'Display Performance'}
        titleIcon={
          <AreaChartOutlined
            style={{
              marginRight: '10px',
              color: 'lightgrey',
              fontSize: 20,
            }}
          />
        }
      />
      <PageContentLayout>
        <Space size={16} style={{ width: '100%' }} direction="vertical">
          <>
            <Col xs={24}>
              <Row gutter={[18, 18]}>
                <Col xs={24}>
                  <Row gutter={[18, 18]}>
                    <Col xs={24}>
                      <Card bordered={false}>
                        <FiltersBar
                          reportData={byDate}
                          history={history}
                          orgs={orgs}
                          campaignOrders={campaignOrders}
                          selectedCOIds={selectedCOIds}
                          setSelectedCOIds={setSelectedCOIds}
                          orgConfigAccess={userPermission}
                          prepareExport={prepareExport}
                          onExportWeeklyReport={onExportWeeklyReport}
                        />
                      </Card>
                      <Card bordered={false} style={{ minHeight: 150 }}>
                        <OrgSummaryChart byDates={byDate} byDay={byDay} />
                      </Card>
                      <Card bordered={false} style={{ minHeight: 300 }}>
                        <CampaignOrderTable
                          tableData={tableData}
                          priceVisible={userPermission.priceVisible} // TODO: Apply Permission here don't merge if this is still here
                        />
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </>
        </Space>
      </PageContentLayout>
    </React.Fragment>
  );
};

export default DisplayPerformanceView;
